import { useEffect} from 'react';
import { Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import AppNavbar from './components/Navbar';
import LoginPage from './components/LoginPage';
import Home from './pages/Home';
import Servicios from './pages/ServiciosPage';
import Ventanillas from './pages/VentanillasPage';
import PantallasPage from './pages/PantallasPage';
import Empresas from './pages/EmpresasPage';
import Salas from './pages/SalasPage';
import Usuarios from './pages/UsuariosPage';
import RecuperarContraseña from './components/RecuperarPassword';
import ResetPasswordModal from './components/ResetPassword';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from './components/ToastContext';
import { api, rawAxios } from './api';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const token = searchParams.get('token');
  const showResetModal = Boolean(email && token);
  const hideNavbar = location.pathname === '/login';
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      try {
         // Obtener la cookie CSRF correctamente
        await rawAxios.get('/sanctum/csrf-cookie');

        // Luego usar la instancia api para pedir /me
        const response = await api.get('/me');
        // const response = await axios.get('/api/me', { withCredentials: true });
        localStorage.setItem('auth', 'true');
        localStorage.setItem('role', response.data.user.role);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      } catch {
        localStorage.clear(); // No autenticado
      }
    };
    checkSession();
  }, []);

  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      res => res,
      err => {
        const message = err.response?.data?.message || '';
        const currentPath = window.location.pathname;

        if (message.includes('MariaDB')) {
          localStorage.clear();

          toast?.showToast?.(
            'danger',
            'No se pudo establecer conexión con la sala. Por favor comuníquese con soporte al correo siteturnos@sitesas.com',
            30000
          );

          const currentPath = window.location.pathname;
          if (!currentPath.includes('/salas')) {
            setTimeout(() => {
              window.location.href = '/salas';
            }, 500);
          }
        }

        if (err.response?.status === 401) {
          // Evitar redirección si estamos en /reset-password con token y email
          const params = new URLSearchParams(window.location.search);
          const token = params.get('token');
          const email = params.get('email');

          const isResetPassword = currentPath === '/reset-password' && token && email;

          if (!isResetPassword) {
            localStorage.clear();
            navigate('/login');
          }
        }

        return Promise.reject(err);
      }
    );

    return () => api.interceptors.response.eject(interceptor);
  }, [navigate]);

  return (
    <>
      {!hideNavbar && <AppNavbar />}
      <div  style={{ maxWidth: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/home"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador', 'consulta']}>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/servicios"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador', 'consulta']}>
                <Servicios />
              </PrivateRoute>
            }
          />
          <Route
            path="/ventanillas"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador', 'consulta']}>
                <Ventanillas />
              </PrivateRoute>
            }
          />
          <Route
            path="/pantallas"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador', 'consulta']}>
                <PantallasPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/empresas"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <Empresas />
              </PrivateRoute>
            }
          />
          <Route
            path="/salas"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador', 'consulta']}>
                <Salas />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute allowedRoles={['admin', 'coordinador']}>
                <Usuarios />
              </PrivateRoute>
            }
          />
          <Route path="/unauthorized" element={<div>No tienes permiso para acceder.</div>} />
          <Route path="/reset-password" element={<RecuperarContraseña />} />
        </Routes>
      </div>
      
      {/* Mostrar modal si hay token y email en la URL */}
      <ResetPasswordModal show={showResetModal} handleClose={() => window.history.replaceState({}, '', '/login')} />
    </>
  );
}

export default App;
